import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35c5ea55"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-edit" }, null, -1));
const _hoisted_2 = [
    _hoisted_1
];
export default /*#__PURE__*/ _defineComponent({
    props: {
        modelValue: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const enableEditMode = () => {
            emits('update:modelValue', true);
        };
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                size: "lg",
                class: "btn btn-warning edit-button btn-circle btn-xl",
                onClick: enableEditMode
            }, _hoisted_2, 512)), [
                [_vShow, !props.modelValue]
            ]);
        };
    }
});
